import dayjs from "dayjs";
import { useMemo } from "react";
import { formattingDurationResult } from "../utils";

export const useGetDuration = (startDateTime: string, endDateTime: string) => {
  return useMemo(() => {
    const startTime = dayjs(startDateTime);
    const finishTime = dayjs(endDateTime);
    const durationTime = dayjs.duration(finishTime.diff(startTime));

    return formattingDurationResult(durationTime);
  }, [endDateTime, startDateTime]);
};
